import { React, reduxConnect } from '../lib/imports';
import { Spacing, CardWithDrawer } from '../components';
import { slotItemBuilder } from './utils';

const Slot = ({ ...props }) => (
  <Spacing sizeBottom='byte'>
    <CardWithDrawer {...props} />
  </Spacing>
);

const mapStateToProps = (state, ownProps) => {
  const { slotId, drawerOpen, defaultAssetUrl, isPlaceholder } = ownProps;
  const { picks, players, teams } = state;
  const { byTeamId } = teams;
  const { byPlayerId, bySlotId, playersPicked } = players;
  const { picked } = picks;

  const playerId = picked[slotId];
  const playersBySlot = bySlotId[slotId];

  const slotBuilder = slotItemBuilder({
    playerData: byPlayerId,
    teamData: byTeamId,
    defaultAssetUrl,
  });

  if (playersPicked) {
    return {
      ...slotBuilder(playerId, isPlaceholder),
      id: slotId,
      items: [],
    };
  }

  const items = playersBySlot ? playersBySlot.map(({ id }) => slotBuilder(id)) : [];

  if (!drawerOpen && playerId) {
    return {
      ...slotBuilder(playerId, isPlaceholder),
      id: slotId,
      items,
    };
  }

  return {
    items,
  };
};

export default reduxConnect(mapStateToProps)(Slot);
